import { ResponseStatusMessage } from '~/defs/response-status-message.enum';
import { Alert } from '~/modules/theme/components/ui/Alert';
import { useSearchParams } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

export interface ResponseStatusAlertProps {}

export const ResponseStatusAlert = ({}: ResponseStatusAlertProps) => {
  const [sp] = useSearchParams();
  const status = sp.get('status');
  const { t } = useTranslation('common');
  if (
    !status ||
    !Object.values(ResponseStatusMessage).includes(
      status as ResponseStatusMessage,
    )
  )
    return null;
  return (
    <Alert
      variant={
        [ResponseStatusMessage.ERROR_IDP.toString()].includes(status!)
          ? 'destructive'
          : 'default'
      }
      className="text-center"
    >
      {t(`common:responseStatus.${status}`)}
    </Alert>
  );
};
